import cloneDeep from 'lodash/cloneDeep.js';
import forEach from 'lodash/forEach.js';
import isEmpty from 'lodash/isEmpty.js';
import keys from 'lodash/keys.js';
import toArray from 'lodash/toArray.js';

export default {
    state: {},

    getters: {
        isEmpty: state => isEmpty(state),
    },

    actions: {
        async sortGradebookStudents({ commit, dispatch }, gradebook) {
            const payload = cloneDeep(gradebook);

            const activities = {};

            payload.activities.forEach(item => {
                activities[item.id] = {};
            });

            await commit('SET_ACTIVITIES', activities);

            await dispatch('addStudentsToActivities', payload.students);

            await commit('HYDRATE_SUBMISSIONS', payload.students);

            await commit('SORT_SUBMISSIONS');
        },

        addStudentsToActivities(context, students) {
            forEach(students, student => {
                context.commit('SET_STUDENTS', student.user_id);
            });
        },
    },

    mutations: {
        EDIT(state, { activity, user, payload }) {
            payload.forEach(item => {
                state[activity][user].submissions[0][item.key] = item.value;
            });
        },

        SET_ACTIVITIES(state, activities) {
            forEach(activities, (value, key) => {
                state[key] = value;
            });
        },

        SET_STUDENTS(state, student) {
            forEach(state, (value, key) => {
                state[key][student] = {};
            });
        },

        HYDRATE_SUBMISSIONS(state, payload) {
            forEach(state, (students, activityId) => {
                forEach(students, (student, studentId) => {
                    const studentIndex = payload.findIndex(item => Number(item.user_id) === Number(studentId));

                    const gradeIndex = payload[studentIndex].user.grades.findIndex(
                        grade => Number(grade.activity_id) === Number(activityId)
                    );

                    const grade = {
                        ...payload[studentIndex],
                        submissions: [payload[studentIndex].user.grades[gradeIndex]],
                    };

                    state[activityId][studentId] = grade;
                });
            });
        },

        SORT_SUBMISSIONS(state) {
            forEach(state, (students, key) => {
                state[key].submissions = toArray(students);
            });

            forEach(state, (activities, key) => {
                const sorted = activities.submissions.sort((a, b) => {
                    return a.user.last_name > b.user.last_name ? 1 : -1;
                });

                state[key].submissions = sorted;
            });
        },

        PURGE(state) {
            if (!isEmpty(state)) {
                const items = keys(state);

                items.forEach(key => {
                    delete state[key];
                });
            }
        },
    },
};
